export default __webpack_public_path__ + "images/arrow_right-c8023c73d1703508d16c19098b7ef9a8.png";